namespace TabAurous.HR {
    export interface IncomeTaxSlabsRow {
        IncomeSlabId?: number;
        Code?: string;
        Narration?: string;
        EffectiveFrom?: string;
        CompanyId?: number;
        CurrencyId?: number;
        StdTaxExemption?: number;
        AllowTaxExemption?: boolean;
        IsDisabled?: boolean;
        TaxSlabDetails?: IncomeTaxSlabDetailsRow[];
    }

    export namespace IncomeTaxSlabsRow {
        export const idProperty = 'IncomeSlabId';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'HR.IncomeTaxSlabs';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            IncomeSlabId = "IncomeSlabId",
            Code = "Code",
            Narration = "Narration",
            EffectiveFrom = "EffectiveFrom",
            CompanyId = "CompanyId",
            CurrencyId = "CurrencyId",
            StdTaxExemption = "StdTaxExemption",
            AllowTaxExemption = "AllowTaxExemption",
            IsDisabled = "IsDisabled",
            TaxSlabDetails = "TaxSlabDetails"
        }
    }
}
